export const i18nModelPage = {
  sections: {
    risk: 'Pontuação de Risco',
    alarmHistory: 'Histórico de Alarmes',
    radar: 'Radar view',
    amoeba: 'Plot view',
    models: 'Modelos de Processo',
  },
};
